import React from 'react';
import { node, string } from 'prop-types';

const ZoneCard = ({ children, className }) => {
  const classNames = `zone-card ${className}`;
  return <div className={classNames}>{children}</div>;
};

ZoneCard.propTypes = {
  children: node.isRequired,
  className: string,
};

ZoneCard.defaultProps = {
  className: '',
};

export default ZoneCard;